
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import OverviewTab from './OverviewTab';
import GameHistoryTab from './GameHistoryTab';
import SOSEventsTab from './SOSEventsTab';
import AnalyticsTab from './AnalyticsTab';

interface ProfileTabsProps {
  stats: any;
  gameHistory: any[];
  sosEvents: any[];
}

const ProfileTabs = ({ stats, gameHistory, sosEvents }: ProfileTabsProps) => {
  return (
    <Tabs defaultValue="overview" className="w-full">
      <TabsList className="grid w-full grid-cols-4">
        <TabsTrigger value="overview">Overview</TabsTrigger>
        <TabsTrigger value="history">Game History</TabsTrigger>
        <TabsTrigger value="sos">SOS Events</TabsTrigger>
        <TabsTrigger value="analytics">Analytics</TabsTrigger>
      </TabsList>
      
      <TabsContent value="overview">
        <OverviewTab stats={stats} />
      </TabsContent>
      
      <TabsContent value="history">
        <GameHistoryTab gameHistory={gameHistory} />
      </TabsContent>
      
      <TabsContent value="sos">
        <SOSEventsTab sosEvents={sosEvents} />
      </TabsContent>
      
      <TabsContent value="analytics">
        <AnalyticsTab />
      </TabsContent>
    </Tabs>
  );
};

export default ProfileTabs;
